<template>
  <Icon v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { Icon } from "ant-design-vue";
export default {
  components: {
    Icon
  }
};
</script>

<style></style>
